const PlusIcon = (props) => {
  const { size = 24, onClick } = props;
  return (
    <svg onClick={onClick} width={size} height={size} fill="currentColor">
      <path d="M10 5a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H6a1 1 0 1 1 0-2h3V6a1 1 0 0 1 1-1Z"></path>
    </svg>
  );
};

export default PlusIcon;
